import React from "react";
import { Skeleton } from "@mui/material";

export default function LoadingSkeletonModule({ place }) {

  const renderDefaultSkeleton = () => (
    <div>
      <Skeleton animation="pulse" variant="rectangular" height={100} style={{ marginBottom: 15, marginTop: 10 }} />
      <Skeleton animation="pulse" variant="rectangular" height={150} style={{ marginBottom: 15 }} />
      <Skeleton animation="pulse" variant="rectangular" height={400} style={{ marginBottom: 15 }} />
    </div>
  );

  const renderProgressSidebarSkeleton = () => (
    <div>
      <Skeleton animation="pulse" variant="rectangular" height={15} style={{ marginBottom: 5, marginTop: 5 }} />
      <Skeleton animation="pulse" variant="rectangular" height={15} style={{ marginBottom: 5, marginTop: 5 }} />
    </div>
  );

  const renderSidebarSkeleton = () => (
    <div style={{ padding: '16px' }}>
      <Skeleton animation="pulse" variant="text" height={40} style={{ marginBottom: 5 }} />
      <Skeleton animation="pulse" variant="text" height={20} style={{ marginBottom: 5 }} />
      <Skeleton animation="pulse" variant="text" height={20} style={{ marginBottom: 5 }} />
      <Skeleton animation="pulse" variant="text" height={20} style={{ marginBottom: 20 }} />

      <Skeleton animation="pulse" variant="text" height={40} style={{ marginBottom: 5 }} />
      <Skeleton animation="pulse" variant="text" height={20} style={{ marginBottom: 5 }} />
      <Skeleton animation="pulse" variant="text" height={20} style={{ marginBottom: 5 }} />
      <Skeleton animation="pulse" variant="text" height={20} style={{ marginBottom: 20 }} />

      <Skeleton animation="pulse" variant="text" height={40} style={{ marginBottom: 5 }} />
      <Skeleton animation="pulse" variant="text" height={20} style={{ marginBottom: 5 }} />
      <Skeleton animation="pulse" variant="text" height={20} style={{ marginBottom: 5 }} />
      <Skeleton animation="pulse" variant="text" height={20} style={{ marginBottom: 20 }} />
    </div>
  );

  switch (place) {
    case "progressSidebar":
      return renderProgressSidebarSkeleton();
    case "sidebar":
      return renderSidebarSkeleton();
    default:
      return renderDefaultSkeleton();
  }
}
